import { ESuburbanOfferFilter } from '@cian/api-models/common/json_query';

export const POSSESOR_TYPE_NAMES = {
  [ESuburbanOfferFilter.Any]: 'От любого владельца',
  [ESuburbanOfferFilter.Builder]: 'От застройщика',
  [ESuburbanOfferFilter.Individual]: 'От собственников и агентов',
};
